// extracted by mini-css-extract-plugin
export default {"slotHighlighted":"kU7dIn"};